export const localNavModule = {
  name: 'Local Nav',
};

export const sectionNavModule = {
  name: 'Section Nav',
};
